module.exports = __webpack_public_path__ + "img/jorn_linne.e27416da.jpg";